"use client"

import { Icon, IconName } from "src/components/generic/Icon"
import { ProviderIconData, ProviderIcons } from "src/components/sections/footer/ProviderIcons"
import { TooltipProps } from "../../generic/Tooltip"

const fulfillmentProviders: ProviderIconData<IconName>[] = [
  { icon: "fulfillment_gls", name: "GLS", background: "#061ab1" },
  { icon: "fulfillment_dpd", name: "DPD" },
  { icon: "fulfillment_dhl", name: "DHL", background: "#fecc00" },
]

export type FulfillmentProvidersProps = {
  size: "lg" | "md" | "sm"
  tooltipVariant?: TooltipProps["variant"]
}

export const FulfillmentProviderIcons = ({ size, tooltipVariant }: FulfillmentProvidersProps) => {
  return (
    <ProviderIcons
      Icon={Icon}
      items={fulfillmentProviders}
      height={size}
      tooltipVariant={tooltipVariant}
      className="aspect-[4/3] bg-white px-1 py-2"
    />
  )
}
